(function () {
    // save the section id from the script tag and find the section
    const sectionID = document.currentScript.dataset.id;
    const section = document.querySelector(`#${sectionID}`);

    // exit if section is not found
    if (!section) {
        console.warn(`Product section with ID ${sectionID} not found.`);
        return;
    }

    // get product data
    const product = JSON.parse(section.querySelector(".productJSON").textContent);

    // note, the starting activeVariant is set in the section liquid file, when options are changed we fetch the new variant data from the server
    let activeVariant = JSON.parse(section.querySelector(".productVariantJSON").textContent);

    // Set this up to be assigned if a selling plan is selected
    let activeSellingPlan;

    // during dev mode, set 344the active variant to the window so it can be accessed in the console
    if (Shopify.theme.role === "development") {
        window.product = product;
        window.activeVariant = activeVariant;
    }

    /************
     Product Swiper
     ************/
    const thumbSwiper = new Swiper(section.querySelector(".productV3ContentMediaThumbs"), {
        spaceBetween: 5,
        slidesPerView: 5,
        freeMode: true,
        watchSlidesProgress: true,
        breakpoints: {
            1000: {
                spaceBetween: 8,
            }
        }, mousewheel: {
            forceToAxis: true
        }

    });
    const productSwiper = new Swiper(section.querySelector(".productV3ContentMediaGallery"), {
        slidesPerView: 1,
        spaceBetween: 20,
        pagination: {
            el: section.querySelector("#productV3ContentMediaGalleryBullets"),
            clickable: true,
        },
        thumbs: {
            swiper: thumbSwiper,
        },
        navigation: {
            nextEl: section.querySelector(".productV3ContentMediaGalleryNext"),
            prevEl: section.querySelector(".productV3ContentMediaGalleryPrev"),
        },
        loop: true
    });

    // play video on slide play click
    section.querySelectorAll(".productVisualSwiperSlide").forEach(element => {
        element.addEventListener("click", function () {
            // get video
            const video = this.closest(".productVisualSwiperSlide").querySelector("video");

            if (!video) {
                return;
            }

            // remove play button if it hasn't already been removed
            this.querySelector(".productVisualSwiperSlidePlay")?.remove();

            // show controls
            video.controls = true;

            // play video
            video.play();
        });
    });


    // update active variant on input changes
    section.querySelectorAll("input, select").forEach(function (element) {
        element.addEventListener("change", function () {
            updateProduct();
        });
    })

    /**
     * Auto selected the options for and pre-selected product variant. This will grab the correct
     * option selectors when a variant ID is passed into the URL.
     * This method allows for direct variant sharing through the URL.
     * Only runs once on initial page load. UpdateProduct handles every consecutive change.
     */
    function init() {
        // collect options from inputs
        let options = activeVariant.options;
        //for each group of radios, find all that are checked
        section.querySelectorAll(`.productV3OptionsInput`).forEach(group => {
            if (options.includes(group.value)) {
                group.checked = true;
            } else {
                group.checked = false;
            }
        });
    }

    /**************
     Update Product
     ***************/

    function isSubscription() {
        if (section.querySelector(".productV3BOrder").classList.contains("active")) {
            return !!section.querySelector(`.productV3BOrderLabelInput[value="sub"]:checked`)
        }
        return !!section.querySelector(`.productV3OrderLabelInput[value="sub"]:checked`);
    }

    async function updateProduct() {

        //const orderV3BExists = section.querySelector(".productV3BOrder").classList.contains("active") ?? true;

        // Find the active variant
        if (product.variants.length === 1) {
            // default fallback
            activeVariant = product.variants[0];
        } else {
            // collect options from inputs
            let options = [];
            //for each group of radios, find all that are checked
            section.querySelectorAll(`.productV3OptionsInput`).forEach(group => {
                if (group.checked) {
                    options.push(group.value);
                }
            });


            // find new variant based on the options
            activeVariant = product.variants.find((variant) => {
                //look for identical arrays
                return JSON.stringify(variant.options) === JSON.stringify(options)
            });
        }

// check if variant wasn't found
        if (!activeVariant) {
            section.querySelector(".productV3CartButton").disabled = true;
            section.querySelector(".productV3CartButton").textContent = "Not Available";
            return;
        }

        // Add the variant ID to the url, if the active variant exists
        const url = new URL(window.location.href);
        url.searchParams.set("variant", activeVariant.id);
        window.history.pushState(null, "", url.href);

        // reset active selling plan when variant changes
        activeSellingPlan = null;

        //CHECK THE RADIO FOR AN ACTIVE SELLING PlAN
        if (section.querySelector(".productV3OrderWrapper")) {
            section.querySelectorAll(".productV3OrderWrapper").forEach(order => {
                const input = order.querySelector(".productV3OrderLabelInput");
                if (input.checked && input.value === "sub") {
                    activeSellingPlan = order.querySelector(".productV3OrderDropSelect").value
                }
            });
        }

        //CHECK THE RADIO FOR ORDERB SELLING PLAN
        if (section.querySelector(".productV3BOrderItem")) {
            section.querySelectorAll(".productV3BOrderItem").forEach(order => {
                const input = order.querySelector(".productV3BOrderLabelInput");
                if (input.checked && input.value === "sub") {
                    activeSellingPlan = order.querySelector(".productV3BOrderLabelDropWrapContentLabelSelect").value
                }
            });
        }

        // SCROLL TO THE VARIANT IMAGE
        if (activeVariant.featured_image) {
            // change active slide
            // IMAGE POSITION ZERO IS WHERE THE ACTIVE VARIANT IMAGE IS ALWAY PRESENT
            productSwiper.slideTo(0);
            //Update the variants image
            section.querySelectorAll(".variantImage").forEach(image => {
                image.src = activeVariant.featured_image.src;
            })
        }

        // Update details section image for the current variant
        // Check to see if the details section exists
        let detailsSection = document.querySelector(".details") || false;
        if (detailsSection) {
            //Get the detailsImages if they are not already there
            if (!detailsImages[activeVariant.id]) {
                await getVariantImages();
            } else {
                //Update the image depending on mobile or desktop sizes.
                if (window.innerWidth < 801) {
                    document.querySelector(".detailsContentMediaImage").src = detailsImages[activeVariant.id].mobile;
                } else {
                    document.querySelector(".detailsContentMediaImage").src = detailsImages[activeVariant.id].desktop;
                }
            }
        }

        let subDiscount = 1;
        //Calculate the selling plan discount
        section.querySelectorAll(".productV3OrderLabelInput").forEach(radio => {
            if (radio.checked && radio.value === "sub") {
                product.selling_plan_groups.forEach((group) => {
                    group.selling_plans.forEach(plan => {
                        if (plan.id === parseInt(section.querySelector(".productV3OrderDropSelect").value)) {
                            subDiscount = 1.00 - (plan.price_adjustments[0].value / 100);
                        }
                    });
                });
            }
        })

        // UPDATE THE PRICE PER UNIT BLOCKS
        //Grab Variant Metafields
        const variantMetafields = section.querySelectorAll(".variantMetafields");
        //Grab the PPU nodes in a list
        const PPUs = section.querySelectorAll(".ItemPPUValue");
        // Create an index counter to prevent over indexing
        let PPUIndex = 0;
        //Determine which pack is selected
        let size;
        section.querySelectorAll(".productV3OptionsSizeItemInput").forEach(option => {
            if (option.checked) {
                size = option.value
            }
        });

        //Loop through all variants to find a match to the active one.
        for (let i = 0; i < product.variants.length; i++) {
            let variant = product.variants[i];
            if (variant.options.includes(size) || !size) {
                PPUs[PPUIndex].textContent = price((variant.price / JSON.parse(variantMetafields[i].dataset.metafields).pack_size) * subDiscount);
                PPUIndex++;
            }
        }

        //Enable the ATC button
        section.querySelector(".productV3CartButton").disabled = false;
        let subPrice = parseInt(activeVariant.price) * 0.85;
        let otpPrice = parseInt(activeVariant.price);
        let comparePrice = ""
        if (parseInt(activeVariant.compare_at_price) > otpPrice && activeVariant.compare_at_price !== "") {
            comparePrice = price(parseInt(activeVariant.compare_at_price));
        }

        //Order buttons variant (new)
        section.querySelector(".productV3BOrderLabelContentPrice.otp").textContent = `${price(otpPrice)}`;
        section.querySelector(".productV3BOrderLabelContentPrice.sub").textContent = `${price(subPrice)}`;
        section.querySelector(".productV3BOrderLabelContentPriceCompare.sub").textContent = `${price(otpPrice)}`;

        //Order Buttons Base
        section.querySelector(".productV3OrderLabelBodyPrice.otp").textContent = `${price(otpPrice)}`;
        section.querySelector(".productV3OrderLabelBodyPrice.sub").textContent = `${price(subPrice)}`;
        section.querySelector(".productV3OrderLabelBodyCompare.sub").textContent = `${price(otpPrice)}`;


        if (isSubscription()) {
            section.querySelector(".productV3CartButton").innerHTML = `ADD TO CART • ${price(subPrice)} <span class="productV3CartButtonCompare">${comparePrice}</span>`;
        } else {
            section.querySelector(".productV3CartButton").innerHTML = `ADD TO CART • ${price(otpPrice)} <span class="productV3CartButtonCompare">${comparePrice}</span>`;
        }
        section.querySelectorAll(".productV3OrderLabelBodyDot").forEach(item => {
            item.classList.add("active");
        });

    }

    // on load, update the product
    // this accomplishes loading the correct variant image and price on page load
    init();
    updateProduct();

    /**************
     Returns button listener
     ***************/
    section.querySelector(".productV3Footnote").addEventListener("click", (e) => {
        section.querySelector(".productV3FootnotePopup").showModal();
    });
    section.querySelector(".productV3FootnotePopupClose").addEventListener("click", (e) => {
        section.querySelector(".productV3FootnotePopup").close();
    });

    /**************
     Ingredients Button listener
     ***************/
    const ingredientsPopup = section.querySelector(`[id="${product.id}-ingredientsPopupV2"]`) || false
    if (ingredientsPopup) {

        //Animation listner to determine if we animated in or our
        ingredientsPopup.addEventListener("animationend", (e) => {
            if (e.animationName === "popupIn") {
                ingredientsPopup.classList.remove("popupIn");
            } else if (e.animationName === "popupOut") {
                ingredientsPopup.close();
                ingredientsPopup.classList.remove("popupOut");
            }
        });

        //Show the modal
        section.querySelector(".productV3Ingredients").addEventListener("click", (e) => {
            ingredientsPopup.classList.add("popupIn");
            ingredientsPopup.showModal();
        });

        //Hide the modal on close button click
        ingredientsPopup.querySelector(".ingredientsPopupV2Close").addEventListener("click", (e) => {
            ingredientsPopup.classList.add("popupOut");
        });
        //hide the modal if background is clicked
        ingredientsPopup.addEventListener("click", (e) => {
            if (e.target === ingredientsPopup) {
                ingredientsPopup.classList.add("popupOut");
            }
        });
    }


    /**************
     Subscription Radio Listener
     ***************/
    section.querySelectorAll(".productV3OrderLabelInput").forEach(element => {
        element.addEventListener("change", (e) => {
            // Remove the active classes on the drop and the radio button
            section.querySelectorAll(".productV3OrderWrapper").forEach(item => {
                item.classList.remove("active");
                section.querySelector(".productV3OrderDrop").classList.remove("active");
            });
            if (e.target.checked) {
                // Set the checked radio to active
                e.target.parentElement.parentElement.classList.add("active");
                if (e.target.value === "sub") {
                    // If its the 'subscription' radio button, make the drop active as well.
                    section.querySelector(".productV3OrderDrop").classList.add("active");
                }
            }
            updateProduct();
        });
    });

    /**************
     ATC Listener
     ***************/
        // Making the ATC button stick to the bottom of the screen
    let atcParent = section.querySelector(".productV3Cart");
    window.addEventListener("scroll", (e) => {
        if (atcParent.getBoundingClientRect().top <= 0) {
            section.querySelector(".productV3CartButton").classList.add("stick");
        } else {
            section.querySelector(".productV3CartButton").classList.remove("stick");
        }
    })


    /**************
     Product ATC function
     ***************/

    async function addToCart() {

        // add loading animation to both buttons
        section.querySelector(".productV3CartButton").classList.add("loading");

        let formData = {
            items: [
                {
                    id: activeVariant.id,
                    quantity: 1,
                }
            ]
        };
        if (activeSellingPlan) {
            formData.items[0].selling_plan = activeSellingPlan;
        }

        // add product
        await addProduct(formData);


        // remove loading animation
        section.querySelector(".productV3CartButton").classList.remove("loading");

        // open cart
        await openCart();

        //OPEN THE UPSELL
        openUpsell(product.id);
    }

    section.querySelector('.productV3CartButton').addEventListener("click", addToCart);
}());